import Glide from '@glidejs/glide';
window.onload = function () {
	let carouselTeam = document.querySelector('.glide_team');
	if (carouselTeam) {
		let glide = new Glide('.glide_team', {
			type: 'carousel',
			perView: 3,
			gap: '40px',
			breakpoints: {
				990: {
					perView: 2
				},
				768: {
					perView: 1
				}
			}
		});

		glide.mount();
	};
	let carouselOpinion = document.querySelector('.glide_opinion');
	if (carouselOpinion) {
		let glide = new Glide('.glide_opinion', {
			type: 'carousel',
			perView: 3,
			gap: '40px',
			autoplay: 3000,
			breakpoints: {
				990: {
					perView: 2
				},
				540: {
					perView: 1
				}
			}
		});

		glide.mount();
	};
	let carouselProyect = document.querySelector('.glide_proyects');
	if (carouselProyect) {
		let glide = new Glide('.glide_proyects', {
			type: 'carousel',
			perView: 3,
			gap: '80px',
			// autoplay: 3000,
			breakpoints: {
				990: {
					perView: 2
				},
				540: {
					perView: 1
				}
			}
		});

		glide.mount();
	};
	let carouselBannner = document.querySelector('.glide__banner');
	if (carouselBannner) {
		let glide = new Glide('.glide__banner', {
			type: 'carousel',
			perView: 1,

		});

		glide.mount();
	};
	if (
		document.querySelector(".main-blog") || document.querySelector(".main-single-blog") || document.querySelector(".main-contact")
	) {
		let header = document.querySelector("header");
		header.classList.toggle("header-blog");
	}
};
